import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store/rootReducer";
import { PaginationState } from "./types";

const initialState: PaginationState = {
  page: 1,
  totalPages: 1,
  totalItems: 0,
};

const pagination = createSlice({
  name: "paginationSlice",
  initialState,
  reducers: {
    setPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    setTotalPages(state, action: PayloadAction<number>) {
      state.totalPages = action.payload;
    },
    setTotalItems(state, action: PayloadAction<number>) {
      state.totalItems = action.payload;
    },
  },
});
export const { setPage, setTotalPages, setTotalItems } = pagination.actions;

export const selectPage = (state: RootState) => state.pagination.page;
export const selectTotalPages = (state: RootState) =>
  state.pagination.totalPages;
export const selectTotalItems = (state: RootState) =>
  state.pagination.totalItems;

export default pagination.reducer;
